<div class="business-documents-component">
  <document-details
    [application]="application"
    [apiUrl]="apiUrl"
    [listApplicationDocumentFn]="listApplicationDocumentFn"
    [downloadApplicationDocumentUrlFn]="downloadApplicationDocumentUrlFn"
    [approveApplicationDocumentFn]="approveApplicationDocumentFn"
    [declineApplicationDocumentFn]="declineApplicationDocumentFn"
    [deleteApplicationDocumentFn]="deleteApplicationDocumentFn"
    [downloadAllApplicationDocumentUrlFn]="downloadAllApplicationDocumentUrlFn"
    [updateApplicationDocumentTagsFn]="updateApplicationDocumentTagsFn"
    [updateApplicationRequiredDocumentsFn]="updateApplicationRequiredDocumentsFn"
     
    [createDocumentWorklistFn]="createDocumentWorklistFn"
    [completeDocumentWorklistFn]="completeDocumentWorklistFn"
    [getUserByAccessLevelFn]="getUserByAccessLevelFn"
    [generateApprovalNoticeFn]="generateApprovalNoticeFn"
    [sendApprovalNoticeEmailFn]="sendApprovalNoticeEmailFn"
    [deleteApprovalNoticeFileFn]="deleteApprovalNoticeFileFn"
    [undoApplicationDocumentFn]="undoApplicationDocumentFn"
    [getUserFn]="getUserFn"
    (scrollEvent)="scrollToChildTwo()"
    (events)="onDocumentDetailsEvent($event)"
    (saveNote)="onSaveNote()"
    [getDisbursementByApplicationIdFn]="getDisbursementByApplicationIdFn"
    [settleLoanFn]="settleLoanFn"
    [updateApplicationStageFn]="updateApplicationStageFn"
    [getApplicationAssetFn]="getApplicationAssetFn"
    [getApplicationByIdFn]="getApplicationByIdFn"
    [updateApplicationStageFn]="updateApplicationStageFn"
    [totalNotesCount]="totalNotesCount"
  ></document-details>

  <div class="notes">
    <asset-notes
      #assetNotesComponent
      [application]="application"
      [createDocumentWorklistFn]="createDocumentWorklistFn"
      [completeDocumentWorklistFn]="completeDocumentWorklistFn"
      [isAssetNoteEditorShow] = "false"
      [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
      [createApplicationNoteFn]="createApplicationNoteFn"
      [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
      (totalNotesEvent)="totalNotes($event)"
    ></asset-notes>
  </div>
</div>
